module.exports = __webpack_public_path__ + "img/selected0-min.a1284ab2.png";